const roleLabels = {
  operator: 'Администратор',
  employee: 'Сотрудник',
  Оператор: 'Администратор',
  Официант: 'Сотрудник',
  Сотрудник: 'Сотрудник',
};

export function mapRoleForUI(role) {
  if (!role) return role;

  if (typeof role === 'string') {
    return roleLabels[role.trim()] || role;
  }

  const label = roleLabels[role.value] || roleLabels[(role.label || '').trim()];
  if (!label) return role;

  return { ...role, label };
}

export function getRoleLabelForUI(role) {
  if (!role) return '';
  const mapped = mapRoleForUI(role);
  return typeof mapped === 'string' ? mapped : mapped?.label || '';
}
